import { motion } from "framer-motion";
import { Heart, GlassWater, Building2, Flower2, Camera, Gift } from "lucide-react";

const services = [
  {
    icon: Heart,
    title: "Svadby",
    text: "Najkrajší deň zaslúži najkrajšie vozidlo. Tatra 603 ako svadobné auto pre nevestu, ženícha a fotografovanie.",
    span: "md:col-span-7 md:row-span-2",
    accent: true,
  },
  {
    icon: GlassWater,
    title: "Oslavy & Výročia",
    text: "Okrúhle jubileá, polnočné prekvapenia, zlaté svadby.",
    span: "md:col-span-5",
  },
  {
    icon: Building2,
    title: "Firemné akcie",
    text: "Reprezentačná jazda pre VIP hostí a obchodných partnerov.",
    span: "md:col-span-5",
  },
  {
    icon: Camera,
    title: "Fotografovanie",
    text: "Profesionálne fotosessions, klipy, reklamné natáčania s dobovým vozidlom.",
    span: "md:col-span-4",
  },
  {
    icon: Gift,
    title: "Darček zážitkov",
    text: "Prekvapte blízkych jedinečnou jazdou autom, ktoré píše históriu.",
    span: "md:col-span-4",
  },
  {
    icon: Flower2,
    title: "Vlastná výzdoba",
    text: "Tatru si môžete ozdobiť podľa svojich predstáv — kvety, stuhy, mašle. Radi pomôžeme s inštaláciou.",
    span: "md:col-span-4",
  },
];

export default function Services() {
  return (
    <section
      id="sluzby"
      data-testid="services-section"
      className="relative py-24 sm:py-36 bg-[#0a0a0a]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div>
            <span className="ornament mb-6">Príležitosti</span>
            <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-cream mt-6 max-w-2xl leading-[1.05]">
              Pre každý okamih,
              <br />
              <em className="text-gold italic font-light">ktorý si zaslúži pozornosť.</em>
            </h2>
          </div>
          <p className="text-cream/60 text-sm max-w-sm leading-relaxed">
            Každý prenájom je individuálny a prispôsobený podľa vašich predstáv.
            Tatru si môžete ozdobiť aj sami — kvetmi, stuhami či ďalšími doplnkami.
            Cena dohodou na základe termínu a rozsahu služieb.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 auto-rows-[minmax(180px,auto)]">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                data-testid={`service-card-${i}`}
                className={`group relative ${s.span} bg-[#111111] border border-white/10 hover:border-gold/50 transition-colors duration-500 p-8 sm:p-10 flex flex-col justify-between overflow-hidden ${
                  s.accent ? "lg:p-14" : ""
                }`}
              >
                {s.accent && (
                  <div
                    className="absolute -right-20 -bottom-20 w-72 h-72 rounded-full opacity-[0.06] blur-3xl bg-gold pointer-events-none"
                  />
                )}
                <div className="flex items-center justify-between">
                  <Icon
                    className="text-gold/90 group-hover:scale-110 transition-transform duration-500"
                    size={s.accent ? 30 : 22}
                    strokeWidth={1.25}
                  />
                  <span className="text-[10px] uppercase tracking-[0.3em] text-cream/40">
                    0{i + 1}
                  </span>
                </div>
                <div className="mt-8">
                  <h3
                    className={`font-serif font-light text-cream tracking-tight ${
                      s.accent ? "text-4xl sm:text-5xl" : "text-2xl"
                    }`}
                  >
                    {s.title}
                  </h3>
                  <p
                    className={`text-cream/60 font-light leading-relaxed mt-3 ${
                      s.accent ? "text-base max-w-md" : "text-sm"
                    }`}
                  >
                    {s.text}
                  </p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
